import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './Header';
import { SearchProvider } from "./SearchContext";
import HomePage from './pages/HomePage/HomePage';
import LoginPage from './pages/LoginPage/LoginPage';
import AddTenantPage from './pages/TenantPage/AddTenantPage';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import TenantPage from './pages/TenantPage/TenantPage';
import NotFound from "./NotFound";


function App() {
    return (
        <Router>
            <Main />
        </Router>
    );
}

function Main() {
    const location = useLocation();   

    const headerRoutes = ["/", "/add-tenant"];
    const showHeader = headerRoutes.some((route) =>
        matchRoute(route, location.pathname)
    );

    return (
        <div>
            {showHeader && <Header />}
            <div className="max-w-screen-xl mx-auto min-h-full px-4 py-8">
                <SearchProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />

                        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                        <Route path="/add-tenant" element={<ProtectedRoute><AddTenantPage /></ProtectedRoute>} />
                        <Route path="/tenant/:tenantName" element={<ProtectedRoute><TenantPage /></ProtectedRoute>} />
                    
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </SearchProvider>
            </div>
        </div>
    );
}

export default App;

function matchRoute(pattern, path) {
    const regex = new RegExp(
        "^" + pattern.replace(/:[^\s/]+/g, "([^/]+)") + "$"
    );
    return regex.test(path);
}
